const BLOCKED = ["fuck", "fucking", "fucker", "shit", "shite", "sh1t", "bitch", "bastard", "cunt", "wanker", "twat", "prick", "dickhead", "asshole", "arsehole", "slut", "whore", "nigger", "nigga", "faggot", "retard", "paki", "spastic", "kike", "chink"];
const RX = new RegExp(`\\b(${BLOCKED.join("|")})\\b`, "i");

export const hasProfanity = (text) => RX.test(text || "");
